module.exports = __webpack_public_path__ + "img/e6361db.jpg";